import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MyDatePickerModule } from 'mydatepicker';
import { FileUploadModule } from 'ng2-file-upload';
import { FileSelectDirective } from 'ng2-file-upload';
import { VoucherRedeemComponent } from './voucher-redeem/voucher-redeem.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { TypeaheadModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';








@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule,
    MyDatePickerModule,
    FileUploadModule,
    CreditCardDirectivesModule,
 TypeaheadModule.forRoot(),
 BsDatepickerModule.forRoot(),
 TimepickerModule.forRoot()





  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    VoucherRedeemComponent
    ]
})
export class VoucherModule {}






// WEBPACK FOOTER //
// ./src/app/views/voucher/voucher.module.ts